import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SVGInline from 'react-svg-inline';
import classNames from 'classnames';

// Icon SVGs
import download from 'assets/icon-download.svg';
import back from 'assets/icon-left-arrow.svg';

// Styles
import styles from './button.scss';

const iconSVGs = {
  download,
  back,
};

const Button = ({
  action,
  className,
  hardLink,
  icon,
  label,
  type,
}) => {
  const Wrapper = ({ children }) => {
    // If a hard link was requested, use a standard anchor tag.
    if (hardLink) {
      return (
        <a
          className={classNames(styles[type], className)}
          href={action}
        >
          {children}
        </a>
      );
    }

    // If the action is a function, use a standard button with a callback.
    if ('function' === typeof action) {
      return (
        <button
          className={classNames(styles[type], className)}
          onClick={action}
        >
          {children}
        </button>
      );
    }

    // Fall back to a React Router link.
    return (
      <Link
        className={classNames(styles[type], className)}
        to={action}
      >
        {children}
      </Link>
    );
  };

  Wrapper.propTypes = { children: PropTypes.node.isRequired };

  return (
    <Wrapper>
      {'' !== icon &&
        <SVGInline
          svg={iconSVGs[icon]}
          className={styles.icon}
          cleanup
        />
      }
      {label}
    </Wrapper>
  );
};

Button.defaultProps = {
  hardLink: false,
  type: 'text',
  className: '',
  icon: '',
};

Button.propTypes = {
  hardLink: PropTypes.bool,
  label: PropTypes.string.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
};

export default Button;



// WEBPACK FOOTER //
// ./app/components/button/index.js